import AnimationProcessing from 'components/animations/processing'
import FouGrid from 'src/components/layout/fou-grid/'
import FouEmailVerify from 'components/general/fou-email-verify';

export default {
  name: 'profile-layout',
  created () {
    window.scrollTo(0, 0)
  },
  components: {
    ...FouGrid,
    FouEmailVerify,
    AnimationProcessing
  },
  props: {
    title: {
      type: String,
      default: 'title'
    },
    subTitle: {
      type: String,
      default: 'subTitle'
    },
    spinner: {
      type: Boolean,
      default: false
    }
  }
}
